<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <div (leafletMapReady)="leafletMapService.init($event)" [leafletOptions]="leafletMapService.mapOptions" class="map"
         id="overviewMap"
         leaflet></div>
    <leaflet-loading-control
        [map]="leafletMapService.mapContainer"
        [options]="leafletMapService.loadingOptions"
    ></leaflet-loading-control>
  </fury-page-layout-content>
</fury-page-layout>
<router-outlet></router-outlet>
